import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Name",
    cell: ({ row }) => (
      <LetterAvatar name={row.original.name} subtitle={row.original.email} />
    ),
  },
  {
    header: "Email",
    accessorKey: "email",
  },
  {
    header: "Phone",
    accessorKey: "phone",
  },
  {
    id: "roles",
    header: "Roles",
    cell: ({ row }) => {
      const roles = row.original.roles ?? []

      return roles.length ? roles.join(", ") : "No role"
    },
  },
  {
    header: "Assigned Branches",
    cell: ({ row }) => {
      const branches = row.original.branches ?? []

      return branches.length
        ? branches.map((branch) => branch.name).join(", ")
        : "No branch access"
    },
  },
]
